import { WrenchIcon, TimerIcon, HelpCircleIcon, WalletIcon, ShieldAlertIcon, FolderOpenIcon, CarIcon } from 'lucide-react'

export const situations = [
  {
    icon: WrenchIcon,
    title: 'An unfamiliar TCM arrives at your workshop.',
    text: "You have the module in front of you, but you don't want to waste an hour figuring out what information matters first.",
  },
  {
    icon: TimerIcon,
    title: 'You spend too much time searching for technical information.',
    text: 'You have saved tutorials, manuals, and notes, but finding the right reference for the job is often the hardest part.',
  },
  {
    icon: HelpCircleIcon,
    title: "You're not always sure what to check next.",
    text: 'You want a structured way to organize the information before choosing your next diagnostic step.',
  },
  {
    icon: WalletIcon,
    title: "You own several tools but aren't always sure which one fits the job.",
    text: "You don't want to spend money on another programmer without first evaluating the requirements and compatibility.",
  },
  {
    icon: ShieldAlertIcon,
    title: "You're concerned about making the wrong move.",
    text: 'You want a consistent preparation and verification process before proceeding with a TCM intervention.',
  },
  {
    icon: FolderOpenIcon,
    title: 'Your diagnostic records and files are difficult to organize.',
    text: 'You need a repeatable way to document identification details, original files, diagnostic observations, and verification results.',
  },
  {
    icon: CarIcon,
    title: 'You want to expand your TCM services.',
    text: 'You know there are opportunities to develop your technical skills, but you want a more structured approach before taking on unfamiliar jobs.',
  },
]
